// extracted by mini-css-extract-plugin
export default {"carousel":"blogSlider_carousel__6RVsB","pagination":"blogSlider_pagination__pmWPM","paginationButton":"blogSlider_paginationButton__1aa7g","is-active":"blogSlider_is-active__PtosQ"};